<template>
    <div class="col col-12 pa-0 rcs-template-builder-v2">
        <v-row no-gutters class="fill-height">
            <!-- Colonne gauche - Formulaire de création (60%) -->
            <v-col cols="12" md="7" class="pa-4">
                <div class="form-sections">
                    <!-- Section 1 : Contenu principal (toujours visible) -->
                    <v-expansion-panels v-model="expandedPanels" multiple class="mb-4">
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                <div class="d-flex align-center">
                                    <v-icon class="mr-3" color="info">$alignleft_s</v-icon>
                                    <div>
                                        <div class="font-weight-bold">Contenu du message</div>
                                        <div class="caption grey--text">
                                            {{ rcsData.message.textContent ? `${rcsData.message.textContent.length} caractères` : 'Texte du message' }}
                                        </div>
                                    </div>
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div >
                                    <!-- Toggle Header -->
                                    <div class="mb-4">
                                        <v-switch
                                            v-model="hasHeader"
                                            label="Ajouter un titre (header)"
                                            color="primary"
                                            hide-details
                                        ></v-switch>
                                    </div>
                                    
                                    <!-- Header si activé -->
                                    <div v-if="hasHeader" class="mb-4">
                                        <vVariableTextField 
                                            :model="rcsData.message" 
                                            :fieldName="'header'" 
                                            :field="{
                                                title: 'Titre du message (optionnel)',
                                                required: false,
                                                props: { 
                                                    counter: 40, 
                                                    label: 'Titre du message (optionnel)',
                                                    hint: 'Maximum 40 caractères',
                                                    solo: true, flat: true, dense: true,
                                                } 
                                            }" 
                                        />
                                    </div>

                                    <!-- Contenu texte -->
                                    <div>
                                        <vVariableTextarea 
                                            :model="rcsData.message" 
                                            :fieldName="'textContent'" 
                                            :field="{
                                                title: 'Contenu du message',
                                                required: true,
                                                props: { 
                                                    counter: 3032, 
                                                    rows: 6,
                                                    label: 'Contenu du message',
                                                    hint: 'Maximum 3032 caractères',
                                                    solo: true, flat: true, dense: true,
                                                }, 
                                                rules:[{'fonction': 'required', 'params': []}]
                                            }" 
                                        />
                                    </div>
                                </div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <!-- Section 2 : Média (section collapsible) -->
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                <div class="d-flex align-center">
                                    <v-icon class="mr-3" color="success">$image_s</v-icon>
                                    <div>
                                        <div class="font-weight-bold">Média (optionnel)</div>
                                        <div class="caption grey--text">
                                            {{ rcsData.mediaFile ? 'Média ajouté' : 'Aucun média' }}
                                        </div>
                                    </div>
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="pa-4">
                                    <!-- Sélecteur de type de média -->
                                    <!-- Pour l'instant, seul le type image est disponible -->
                                    <div class="media-type-selector mb-4" v-if="false">
                                        <div class="d-flex gap-3">
                                            <v-card 
                                                :class="['media-type-card', { 'selected': rcsData.mediaType === 'image' }]"
                                                @click="rcsData.mediaType = 'image'"
                                                hover
                                                outlined
                                                :elevation="rcsData.mediaType === 'image' ? 4 : 1"
                                            >
                                                <v-card-text class="text-center pa-3 position-relative">
                                                    <v-icon 
                                                        v-if="rcsData.mediaType === 'image'"
                                                        color="primary"
                                                        size="16"
                                                        class="selection-indicator"
                                                    >
                                                        $check_s
                                                    </v-icon>
                                                    <v-icon 
                                                        :color="rcsData.mediaType === 'image' ? 'primary' : 'grey'"
                                                        size="32"
                                                        class="mb-2"
                                                    >
                                                        $image_s
                                                    </v-icon>
                                                    <div class="font-weight-bold" :class="rcsData.mediaType === 'image' ? 'primary--text' : 'grey--text'">
                                                        Image
                                                    </div>
                                                </v-card-text>
                                            </v-card>
                                        </div>
                                    </div>

                                    <!-- Zone de téléchargement améliorée -->
                                    <!-- Pour l'instant, seul le type image est disponible -->
                                    <div>
                                        <div v-if="rcsData.mediaFile" class="media-preview-card mb-4">
                                            <div class="d-flex align-center">
                                                <v-img 
                                                    :src="getImageUrl(rcsData.mediaFile)" 
                                                    class="media-thumbnail mr-4"
                                                    max-width="100"
                                                    max-height="100"
                                                >
                                                    <template v-slot:placeholder>
                                                        <div class="d-flex align-center justify-center fill-height">
                                                            <v-progress-circular indeterminate color="grey"></v-progress-circular>
                                                        </div>
                                                    </template>
                                                </v-img>
                                                <div class="flex-grow-1">
                                                    <div class="font-weight-bold">{{ getFileName(rcsData.mediaFile) }}</div>
                                                    <div class="caption grey--text">Image sélectionnée</div>
                                                </div>
                                                <v-btn icon @click="removeMedia">
                                                    <v-icon color="error">$delete</v-icon>
                                                </v-btn>
                                            </div>
                                        </div>
                                        <VFileInputDirect
                                            v-if="!rcsData.mediaFile"
                                            :model="rcsData"
                                            :fieldName="'mediaFile'"
                                            :field="{ 
                                                fileRule: { maxSize: 10240000 }, 
                                                props: { accept: '.png, .gif, .jpg, .jpeg' } 
                                            }"
                                        />
                                        <p class="caption mt-2 grey--text">
                                            Formats : JPEG, PNG - Max 100 Mo - Ratio 1:1 à 16:9
                                        </p>
                                    </div>
                                </div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <!-- Section 3 : Actions (section collapsible) -->
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                <div class="d-flex align-center">
                                    <v-icon class="mr-3" color="purple">$arrow_pointer_d</v-icon>
                                    <div>
                                        <div class="font-weight-bold">Actions (optionnel)</div>
                                        <div class="caption grey--text">
                                            {{ rcsData.buttons.length }} / 4 bouton{{ rcsData.buttons.length > 1 ? 's' : '' }}
                                        </div>
                                    </div>
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="pa-4">
                                    <!-- Liste des boutons sous forme de cartes -->
                                    <div v-if="rcsData.buttons.length > 0" class="buttons-list mb-4">
                                        <v-card
                                            v-for="(button, index) in rcsData.buttons"
                                            :key="index"
                                            class="button-card mb-3"
                                            @click="openButtonDialog(index)"
                                            hover
                                        >
                                            <v-card-text class="d-flex align-center pa-3">
                                                <div class="button-icon-wrapper mr-3">
                                                    <v-icon :color="getButtonColor(button.action)" size="20">
                                                        {{ getButtonIcon(button.action) }}
                                                    </v-icon>
                                                </div>
                                                <div class="flex-grow-1">
                                                    <div class="d-flex align-center">
                                                        <span class="font-weight-bold">{{ button.label || 'Bouton sans nom' }}</span>
                                                        <v-chip 
                                                            x-small 
                                                            :color="getButtonColor(button.action)" 
                                                            text-color="white"
                                                            class="ml-2"
                                                        >
                                                            {{ getButtonTypeLabel(button.action) }}
                                                        </v-chip>
                                                    </div>
                                                    <div class="caption grey--text mt-1">
                                                        {{ getButtonDescription(button) }}
                                                    </div>
                                                </div>
                                                <div class="d-flex align-center">
                                                    <v-btn icon small @click.stop="removeButton(index)">
                                                        <v-icon small>$delete</v-icon>
                                                    </v-btn>
                                                </div>
                                            </v-card-text>
                                        </v-card>
                                    </div>

                                    <!-- Menu pour sélectionner le type d'action -->
                                    <v-menu 
                                        v-if="rcsData.buttons.length < 4"
                                        v-model="actionTypeMenu"
                                        offset-y
                                        :close-on-content-click="true"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn 
                                                color="primary" 
                                                outlined 
                                                block
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                <v-icon left small>$plus_r</v-icon>
                                                Ajouter une action
                                            </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item
                                                v-for="(type, index) in buttonTypes"
                                                :key="index"
                                                @click="selectActionType(type.action)"
                                                :disabled="type.disabled === true"
                                            >
                                                <v-list-item-icon>
                                                    <v-icon :color="getButtonColor(type.action)">{{ getButtonIcon(type.action) }}</v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-content>
                                                    <v-list-item-title>{{ type.text }}</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                    <v-alert v-else color="info" dense text>
                                        Maximum 4 boutons d'action autorisés
                                    </v-alert>
                                </div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </div>
            </v-col>

            <!-- Colonne droite - Prévisualisation (40%) -->
            <v-col cols="12" md="5" class="pa-4">
                <v-card class="preview-container" rounded="lg" sticky>
                    <v-card-title class="d-flex align-center justify-space-between">
                        <div class="d-flex align-center">
                            <v-icon class="mr-2" color="primary" small>$mobile_r</v-icon>
                            Prévisualisation
                        </div>
                        <v-chip small color="primary" outlined>
                            Temps réel
                        </v-chip>
                    </v-card-title>
                    <v-card-text class="text-center">
                        <!-- Mockup smartphone -->
                        <div class="phone-mockup">
                            <div class="phone-frame">
                                <!-- Header du message -->
                                <div class="message-header">
                                    <div class="d-flex align-center">
                                        <v-avatar size="32" color="lightgrey">
                                            <img
                                                src='https://cdn.dev.media.upyourbizz.com/data/DEMO/53/18/0d/8559ad681e-169537244079.png'
                                                alt="logo"
                                            >
                                        </v-avatar>
                                        <div class="ml-2">
                                            <div class="font-weight-bold text-left">{{ expeditor && expeditor.label ? expeditor.label : 'UpYourSoft' }}</div>
                                            <div class="caption">Message RCS</div>
                                        </div>
                                    </div>
                                    <div class="message-time">Maintenant</div>
                                </div>

                                <!-- Contenu du message -->
                                <div class="message-content">
                                    <!-- Média sans bulle -->
                                    <!-- Pour l'instant, seul le type image est disponible -->
                                    <div v-if="rcsData.mediaFile && rcsData.mediaType === 'image'" class="message-media-container">
                                         <!-- Affichage de l'image -->
                                         <div v-if="rcsData.mediaFile" class="message-image">
                                             <div class="media-preview-container">
                                                <v-img 
                                                    :src="getImageUrl(rcsData.mediaFile)" 
                                                    class="rounded media-preview"
                                                    :max-height="180"
                                                    :max-width="263"
                                                >
                                                     <template v-slot:placeholder>
                                                         <div class="d-flex align-center justify-center fill-height">
                                                             <v-progress-circular indeterminate color="white"></v-progress-circular>
                                                         </div>
                                                     </template>
                                                 </v-img>
                                             </div>
                                         </div>
                                    </div>

                                    <!-- Deuxième message : Header, texte et boutons -->
                                    <div v-if="rcsData.message.header || rcsData.message.textContent || rcsData.buttons.length > 0" 
                                         :class="['message-bubble', { 'message-bubble-with-image': rcsData.mediaFile && rcsData.mediaType === 'image' }]">
                                        <!-- Header (titre de prévisualisation) -->
                                        <div v-if="rcsData.message.header" class="message-preview-header">
                                            {{ rcsData.message.header }}
                                        </div>

                                        <!-- Contenu texte -->
                                        <div v-if="rcsData.message.textContent" class="message-text" v-html="rcsData.message.textContent">
                                        </div>

                                        <!-- Boutons d'action -->
                                        <div v-if="rcsData.buttons.length > 0" class="message-buttons">
                                            <v-btn 
                                                v-for="(button, index) in rcsData.buttons" 
                                                :key="index"
                                                :class="['message-button', index === 0 ? 'message-button-primary' : 'message-button-secondary']"
                                                :disabled="!isButtonValid(button)"
                                            >
                                                {{ button.label || 'Bouton' }}
                                            </v-btn>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p class="caption mt-2 grey--text">
                                Aperçu simulé — le rendu peut varier selon l'appareil
                            </p>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Dialog de configuration de bouton -->
        <VRcsButtonConfigDialog
            v-model="buttonDialogOpen"
            :button="currentButton"
            :buttonIndex="currentButtonIndex"
            :totalButtons="rcsData.buttons.length"
            :buttonTypes="buttonTypes"
            @save="saveButtonConfig"
            @previous="previousButton"
            @next="nextButton"
        />
    </div>
</template>

<script>
import validate from "../functions/validations";
import VVariableTextarea from '@/components/forms/inputs/v-custom-variable-textarea';
import VFileInputDirect from "@/components/forms/inputs/v-file-input-direct.vue";
import VVariableTextField from '@/components/forms/inputs/v-custom-variable-text-field';
import VRcsButtonConfigDialog from './v-rcs-button-config-dialog.vue';
import GenericDataService from '@/services/GenericDataService';

export default {
    name: "VCustomTemplateRcsV2",
    components: { 
        VVariableTextarea, 
        VFileInputDirect, 
        VVariableTextField,
        VRcsButtonConfigDialog
    },
    props: ["model", "fieldName", "field"],
    mixins: [validate],
    data() {
        return {
            // Données du message RCS
            rcsData: {
                messageType: 'media-message',
                message: {
                    textContent: '',
                    header: '',
                },
                mediaType: 'image',
                mediaFile: null,
                buttons: [],
                cards: []
            },
            
            // État des panneaux expansibles
            expandedPanels: [0], // Premier panneau ouvert par défaut
            
            // État du header
            hasHeader: false,
            
            // Menu de sélection du type d'action
            actionTypeMenu: false,
            
            // Dialog de configuration de bouton
            buttonDialogOpen: false,
            currentButton: {},
            currentButtonIndex: null,
            isNewButton: false, // Flag pour savoir si on crée un nouveau bouton
            
            // Types de boutons disponibles
            buttonTypes: [
                { text: 'Ouvrir URL', action: 'Openurl' },
                { text: 'Appel téléphonique', action: 'Dial', disabled: false },
                { text: 'Partager localisation', action: 'viewLocation', disabled: false },
                // { text: 'Ajout au calendrier', action: 'CreateCalendarEvent', disabled: false }
            ],
            expeditor: null,
        }
    },
    
    mounted() {
        // Initialiser les données si elles existent déjà
        if (this.model[this.fieldName]) {
            this.rcsData = { ...this.rcsData, ...this.model[this.fieldName] };
        }
        // Forcer le type de média à 'image' (seul type disponible pour l'instant)
        this.rcsData.mediaType = 'image';
        // Normaliser la structure des boutons existants
        this.normalizeButtons();
        // Initialiser l'état du header
        this.hasHeader = !!this.rcsData.message.header;
        // recupération des setting de l'entité associée
        this.expeditor = this.getEntitySettings(this.model.entity_id);
    },
    
    watch: {
        rcsData: {
            handler(newVal) {
                // Synchroniser avec le model parent
                this.model[this.fieldName] = { ...newVal };
                this.$emit('input', newVal);
            },
            deep: true,
            immediate: false
        },
        
        // Watcher pour les données entrantes
        model: {
            handler(newModel) {
                if (newModel && newModel[this.fieldName] && JSON.stringify(newModel[this.fieldName]) !== JSON.stringify(this.rcsData)) {
                    this.rcsData = { ...this.rcsData, ...newModel[this.fieldName] };
                    this.normalizeButtons();
                    this.hasHeader = !!this.rcsData.message.header;
                }
            },
            deep: true,
            immediate: true
        },
        
        // Watcher pour le header
        hasHeader(newVal) {
            if (!newVal) {
                this.rcsData.message.header = '';
            }
        },
        
        // Watcher pour normaliser les boutons
        'rcsData.buttons': {
            handler(newButtons) {
                if (newButtons) {
                    newButtons.forEach(button => {
                        this.ensureButtonStructure(button);
                        if (button.action === 'viewLocation' && button.label) {
                            if (!button.viewLocation) {
                                button.viewLocation = {
                                    latitude: '',
                                    longitude: '',
                                    label: ''
                                };
                            }
                            if (button.viewLocation.label !== button.label) {
                                button.viewLocation.label = button.label;
                            }
                        }
                    });
                }
            },
            deep: true
        },
        
        // Watcher pour forcer le type de média à 'image'
        'rcsData.mediaType'(newType) {
            if (newType !== 'image') {
                this.rcsData.mediaType = 'image';
            }
        },
        
        // Watcher pour gérer la fermeture du dialog sans sauvegarde
        buttonDialogOpen(newVal) {
            if (!newVal && this.isNewButton) {
                // Le dialog s'est fermé sans sauvegarder un nouveau bouton
                // Réinitialiser les variables
                this.currentButton = {};
                this.currentButtonIndex = null;
                this.isNewButton = false;
            }
        }
    },
    
    methods: {
        // Sélectionner le type d'action et ouvrir le dialog
        selectActionType(actionType) {
            this.actionTypeMenu = false; // Fermer le menu
            this.addButton(actionType);
        },
        
        // Gestion des boutons
        addButton(actionType = 'Openurl') {
            if (this.rcsData.buttons.length < 4) {
                const newButton = { 
                    label: '', 
                    action: actionType
                };
                
                // Ajouter uniquement les propriétés nécessaires selon l'action
                if (actionType === 'Openurl') {
                    newButton.url = '';
                    newButton.openUrlProperties = {
                        application: 'WEBVIEW',
                        webviewMode: 'full'
                    };
                } else if (actionType === 'Dial') {
                    newButton.dial = {
                        PhoneNumber: ''
                    };
                } else if (actionType === 'viewLocation') {
                    newButton.viewLocation = {
                        latitude: '',
                        longitude: '',
                        label: ''
                    };
                } else if (actionType === 'CreateCalendarEvent') {
                    newButton.calendar = {
                        title: '',
                        description: '',
                        startTime: '',
                        endTime: ''
                    };
                }
                
                // Ne pas ajouter à la liste, ouvrir directement le dialog
                // currentButtonIndex sera null pour indiquer qu'on crée un nouveau bouton
                this.currentButtonIndex = null;
                this.currentButton = JSON.parse(JSON.stringify(newButton));
                this.isNewButton = true;
                this.buttonDialogOpen = true;
            }
        },
        
        openButtonDialog(index) {
            this.currentButtonIndex = index;
            this.currentButton = JSON.parse(JSON.stringify(this.rcsData.buttons[index]));
            this.isNewButton = false; // C'est un bouton existant, pas un nouveau
            this.buttonDialogOpen = true;
        },
        
        saveButtonConfig(button) {
            // Nettoyer la structure avant de sauvegarder
            this.cleanButtonStructure(button);
            
            if (this.currentButtonIndex === null) {
                // Nouveau bouton : l'ajouter à la liste
                this.rcsData.buttons.push(button);
                this.isNewButton = false; // Réinitialiser le flag après sauvegarde
            } else {
                // Bouton existant : le mettre à jour
                this.$set(this.rcsData.buttons, this.currentButtonIndex, button);
            }
        },
        
        previousButton() {
            if (this.currentButtonIndex > 0) {
                this.saveButtonConfig(this.currentButton);
                this.openButtonDialog(this.currentButtonIndex - 1);
            }
        },
        
        nextButton() {
            if (this.currentButtonIndex < this.rcsData.buttons.length - 1) {
                this.saveButtonConfig(this.currentButton);
                this.openButtonDialog(this.currentButtonIndex + 1);
            }
        },
        
        // Normaliser la structure de tous les boutons
        normalizeButtons() {
            if (this.rcsData.buttons && Array.isArray(this.rcsData.buttons)) {
                this.rcsData.buttons.forEach(button => {
                    this.ensureButtonStructure(button);
                    this.cleanButtonStructure(button);
                });
            }
        },
        
        // S'assurer qu'un bouton a la structure correcte selon son action
        ensureButtonStructure(button) {
            if (!button) return;
            
            if (!button.action) button.action = 'Openurl';
            if (!button.label) button.label = '';
            
            const action = button.action;
            
            // Initialiser uniquement les propriétés nécessaires selon l'action
            if (action === 'Openurl') {
                if (button.url === undefined) button.url = '';
                if (!button.openUrlProperties) {
                    button.openUrlProperties = {
                        application: 'WEBVIEW',
                        webviewMode: 'full'
                    };
                }
            } else if (action === 'Dial') {
                if (!button.dial) {
                    button.dial = {
                        PhoneNumber: ''
                    };
                } else if (button.dial.PhoneNumber === undefined) {
                    button.dial.PhoneNumber = '';
                }
            } else if (action === 'viewLocation') {
                if (!button.viewLocation) {
                    button.viewLocation = {
                        latitude: '',
                        longitude: '',
                        label: ''
                    };
                } else {
                    if (button.viewLocation.latitude === undefined) button.viewLocation.latitude = '';
                    if (button.viewLocation.longitude === undefined) button.viewLocation.longitude = '';
                    if (button.viewLocation.label === undefined) button.viewLocation.label = '';
                }
                if (button.label) {
                    button.viewLocation.label = button.label;
                }
            } else if (action === 'CreateCalendarEvent') {
                if (!button.calendar) {
                    button.calendar = {
                        title: '',
                        description: '',
                        startTime: '',
                        endTime: ''
                    };
                } else {
                    if (button.calendar.title === undefined) button.calendar.title = '';
                    if (button.calendar.description === undefined) button.calendar.description = '';
                    if (button.calendar.startTime === undefined) button.calendar.startTime = '';
                    if (button.calendar.endTime === undefined) button.calendar.endTime = '';
                }
            }
        },
        
        // Nettoyer la structure d'un bouton pour ne garder que les propriétés nécessaires
        cleanButtonStructure(button) {
            if (!button || !button.action) return;
            
            const action = button.action;
            
            // Supprimer les propriétés des autres actions
            if (action !== 'Openurl') {
                delete button.url;
                delete button.openUrlProperties;
            }
            
            if (action !== 'Dial') {
                delete button.dial;
            }
            
            if (action !== 'viewLocation') {
                delete button.viewLocation;
            }
            
            if (action !== 'CreateCalendarEvent') {
                delete button.calendar;
            }
        },
        
        removeButton(index) {
            this.rcsData.buttons.splice(index, 1);
        },
        
        // Gestion du média
        removeMedia() {
            this.rcsData.mediaFile = null;
        },
        
        getFileName(filePath) {
            if (!filePath) return '';
            if (typeof filePath === 'object' && filePath.name) {
                return filePath.name.length > 20 ? filePath.name.substring(0, 20) + '...' : filePath.name;
            }
            if (typeof filePath === 'object' && filePath.title) {
                return filePath.title.length > 20 ? filePath.title.substring(0, 20) + '...' : filePath.title;
            }
            const fileName = filePath.split('/').pop();
            return fileName.length > 20 ? fileName.substring(0, 20) + '...' : fileName;
        },
        
        getImageUrl(mediaFile) {
            if (!mediaFile) return '';
            
            // Si c'est une chaîne, retourner directement
            if (typeof mediaFile === 'string') {
                return mediaFile;
            }
            
            // Si c'est un objet, chercher l'URL appropriée
            if (typeof mediaFile === 'object') {
                // Priorité à l'URL complète
                if (mediaFile.url) {
                    return mediaFile.url;
                }
                // Sinon utiliser la miniature
                if (mediaFile.thumb) {
                    return mediaFile.thumb + '?option=x300,y200,crop';
                }
            }
            
            return '';
        },
        
        // Utilitaires pour les boutons
        getButtonIcon(action) {
            const iconMap = {
                'Openurl': '$link_d',
                'Dial': '$phone_d',
                'viewLocation': '$mapmarker_d',
                'CreateCalendarEvent': '$calendar_d'
            };
            return iconMap[action] || '$arrow_pointer_d';
        },
        
        getButtonColor(action) {
            const colorMap = {
                'Openurl': 'blue',
                'Dial': 'green',
                'viewLocation': 'orange',
                'CreateCalendarEvent': 'purple'
            };
            return colorMap[action] || 'grey';
        },
        
        getButtonTypeLabel(action) {
            const labelMap = {
                'Openurl': 'URL',
                'Dial': 'Appel',
                'viewLocation': 'Localisation',
                'CreateCalendarEvent': 'Calendrier'
            };
            return labelMap[action] || action;
        },
        
        getButtonDescription(button) {
            switch (button.action) {
                case 'Openurl':
                    return button.url || 'URL non définie';
                case 'Dial':
                    return (button.dial && button.dial.PhoneNumber) || 'Numéro non défini';
                case 'viewLocation':
                    return button.viewLocation && button.viewLocation.latitude 
                        ? `${button.viewLocation.latitude}, ${button.viewLocation.longitude}`
                        : 'Coordonnées non définies';
                case 'CreateCalendarEvent':
                    if (!button.calendar || !button.calendar.title) {
                        return 'Événement non défini';
                    }
                    let description = button.calendar.title;
                    if (button.calendar.startTime && button.calendar.endTime) {
                        const startDate = new Date(button.calendar.startTime);
                        const endDate = new Date(button.calendar.endTime);
                        if (!isNaN(startDate.getTime()) && !isNaN(endDate.getTime())) {
                            const startStr = this.formatDateTime(startDate);
                            const endStr = this.formatDateTime(endDate);
                            description += ` - ${startStr} → ${endStr}`;
                        }
                    }
                    return description;
                default:
                    return 'Action non configurée';
            }
        },
        
        formatDateTime(date) {
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${day}/${month}/${year} ${hours}:${minutes}`;
        },
        
        // Vérifier si un bouton est valide selon son type
        isButtonValid(button) {
            if (!button.label) return false;
            
            switch (button.action) {
                case 'Openurl':
                    return !!button.url && this.isValidUrl(button.url);
                case 'Dial':
                    return !!(button.dial && button.dial.PhoneNumber) && this.isValidPhone(button.dial.PhoneNumber);
                case 'viewLocation':
                    return !!(button.viewLocation && 
                             button.viewLocation.latitude && 
                             button.viewLocation.longitude &&
                             this.isValidLatitude(button.viewLocation.latitude) &&
                             this.isValidLongitude(button.viewLocation.longitude));
                case 'CreateCalendarEvent':
                    if (!button.calendar) return false;
                    if (!button.calendar.title) return false;
                    if (!button.calendar.startTime) return false;
                    if (!button.calendar.endTime) return false;
                    const startDate = new Date(button.calendar.startTime);
                    const endDate = new Date(button.calendar.endTime);
                    return endDate > startDate;
                default:
                    return true;
            }
        },
        
        // Utilitaires de validation
        isValidUrl(string) {
            try {
                new URL(string);
                return true;
            } catch (_) {
                return false;
            }
        },
        
        isValidPhone(string) {
            const phoneRegex = /^[\+]?[0-9\s\-\(\)]{10,}$/;
            return phoneRegex.test(string);
        },
        
        isValidLatitude(string) {
            const lat = parseFloat(string);
            return !isNaN(lat) && lat >= -90 && lat <= 90;
        },
        
        isValidLongitude(string) {
            const lng = parseFloat(string);
            return !isNaN(lng) && lng >= -180 && lng <= 180;
        },

        getEntitySettings(entityId) {
            GenericDataService.getData('/entity/get?id=' + entityId).then(response => {
                this.expeditor = response.data.data.settings.rcs_agent ? response.data.data.settings.rcs_agent : {};
            });
        }
    },
    computed: {
        logo: function(){
            return this.$store.state.logo
        }
    }
};
</script>

<style lang="scss" scoped>
.rcs-template-builder-v2 {
    .form-sections {
        .media-type-selector {
            .media-type-card {
                cursor: pointer;
                transition: all 0.3s ease;
                border-radius: 8px;
                min-width: 100px;
                flex: 1;
                
                &:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 25px rgba(0,0,0,0.15);
                }
                
                &.selected {
                    border: 2px solid var(--v-primary-base);
                    background: linear-gradient(135deg, rgba(22, 20, 89, 0.05), rgba(95, 4, 255, 0.05));
                }
                
                .selection-indicator {
                    position: absolute;
                    top: 8px;
                    right: 8px;
                    background: white;
                    border-radius: 50%;
                    padding: 2px;
                    box-shadow: 0 1px 4px rgba(0,0,0,0.15);
                }
            }
        }
        
        .media-preview-card {
            border: 1px solid #e0e0e0;
            border-radius: 8px;
            padding: 1rem;
            background: #f5f5f5;
            
            .media-thumbnail {
                border-radius: 8px;
            }
        }
        
        .buttons-list {
            .button-card {
                cursor: pointer;
                transition: all 0.2s ease;
                
                &:hover {
                    transform: translateX(4px);
                    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
                }
                
                .button-icon-wrapper {
                    width: 40px;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 50%;
                    background: #f5f5f5;
                }
            }
        }
    }
    
    .preview-container {
        position: sticky;
        top: 20px;
        
        .phone-mockup {
            .phone-frame {
                max-width: 300px;
                margin: 0 auto;
                border: 2px solid #e0e0e0;
                border-radius: 20px;
                padding: 1rem;
                background: #f5f5f5;
                min-height: 600px;
                
                .message-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 0.5rem 0;
                    border-bottom: 1px solid #e0e0e0;
                    margin-bottom: 1rem;
                    
                    .message-time {
                        font-size: 0.75rem;
                        color: #666;
                    }
                }
                
                .message-content {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    width: 100%;
                    
                    .message-bubble {
                        background: white;
                        color: black;
                        padding: 1rem;
                        border-radius: 12px;
                        margin-top: 0;
                        margin-bottom: 0.15rem;
                        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                        width: 100%;
                        
                        &.message-bubble-with-image {
                            border-radius: 0;
                            border-bottom-left-radius: 12px;
                            border-bottom-right-radius: 12px;
                        }
                    }
                    
                    .message-media-container {
                        padding: 0;
                        margin: 0;
                        overflow: visible;
                        display: block;
                        width: 100%;
                        
                        .message-image {
                            margin: 0;
                            padding: 0;
                            display: block;
                            width: 100%;
                            
                            .media-preview-container {
                                margin: 0;
                                padding: 0;
                                border-radius: 0;
                                border-top-left-radius: 12px;
                                border-top-right-radius: 12px;
                                overflow: hidden;
                                display: block;
                                position: relative;
                                width: 100%;
                                
                                ::v-deep .v-img {
                                    width: 100% !important;
                                    border-radius: 0 !important;
                                    border-top-left-radius: 12px !important;
                                    border-top-right-radius: 12px !important;
                                }
                            }
                        }
                        
                        .message-pdf .pdf-preview-container,
                        .message-video .video-preview-container {
                            border-radius: 12px 12px 12px 0px;
                            overflow: hidden;
                            width: 100%;
                        }
                    }
                    
                    .message-preview-header {
                        font-weight: bold;
                        font-size: 1.1rem;
                        line-height: 1.4;
                        text-align: left;
                        margin: 0 0 0.5rem 0;
                        padding: 0;
                        color: black;
                    }
                    
                    .message-text {
                        white-space: pre-wrap;
                        line-height: 1.5;
                        text-align: left;
                        margin: 0.5rem 0;
                        color: black;
                        font-size: 0.95rem;
                    }
                    
                    .message-buttons {
                        margin-top: 1rem;
                        display: flex;
                        gap: 0.5rem;
                        flex-wrap: wrap;
                        
                        .message-button {
                            flex: 1;
                            min-width: 120px;
                            padding: 0.75rem 1rem;
                            text-transform: none;
                            font-weight: 500;
                            border-radius: 8px;
                            box-shadow: none;
                            
                            &.message-button-primary {
                                background: black !important;
                                color: white !important;
                            }
                            
                            &.message-button-secondary {
                                background: white !important;
                                color: black !important;
                                border: 1px solid black !important;
                            }
                        }
                    }
                }
            }
        }
    }
}

.gap-3 {
    gap: 1rem;
}
</style>

